// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'page-header',
    templateUrl: './page-header.component.html',
    standalone: false,
})
export class PageHeaderComponent implements OnInit {
    @Input() headerType?: string;
    @Input() icon?: string;
    @Input() header!: string;
    @Input() subHeader?: string;
    @Input() panelLeftClass?: string;
    @Input() panelRightClass?: string;
    @Input() panelClass?: string;
    @Input() trustAsHtml?: boolean;
    @Input() word?: string;
    @Input() subHeaderTooltipPlacement?: string;
    @Input() subHeaderTooltipEnable?: boolean;

    ngOnInit (): void {
        this.panelClass = this.panelClass || '';
        this.headerType = this.headerType || '1';
        if (typeof this.trustAsHtml !== 'boolean') {
            this.trustAsHtml = true;
        }

        if (typeof this.subHeaderTooltipPlacement !== 'string' || this.subHeaderTooltipPlacement.trim().length === 0) {
            this.subHeaderTooltipPlacement = 'bottom';
        }

        if (typeof this.subHeaderTooltipEnable !== 'boolean') {
            this.subHeaderTooltipEnable = true;
        }
    }

    getLeftClass (): string {
        if (typeof this.panelLeftClass === 'string' && this.panelLeftClass.length > 0) {
            return this.panelLeftClass;
        }
        return '';
    }

    getIconContainerClasses (): string[] {
        const classes = [this.icon || ''];
        if (this.headerType === '2') {
            classes.push('header-two');
        }
        return classes;
    }

    getRightClass (): string {
        if (typeof this.panelRightClass === 'string' && this.panelRightClass.length > 0) {
            return this.panelRightClass;
        }
        return '';
    }

    getWord (): string {
        const headerWord = this.header.split('- ');
        const word = headerWord[1];
        return word;
    }
}
